import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { CreatePlanForm } from "./create-plan.form";
import { useSaveData } from "../../../../../../hooks/useSaveData";
import { MutationKeyConfig } from "../../../../../../api/api-helper";
import { InvalidateRoute } from "../../../../../../hooks/useDeleteData";
import { useReactHookForm } from "../../../../../../hooks/useReactHookForm";
import { ReactHookForm } from "../../../../../../components/hook-form/react-hook-form.component";
import { CreatePlanComponent } from "./create-plan/create-plan.component";
import { PlanMappedComponent } from "./map-plans/plan-mapped.component";
import { TabPanel } from "../../../../../../components/tab-panel";
import { planApiKeyStore } from "../../../../../../api/plan-api-key-store";

const styling = {
    tabHeading: { fontWeight: 'bold' },
};

interface UploadPlanDialog {
    data: any;
    planData: any[];
    mapPlanData: any;
    yupSchema?: any;
    onSavedPlan: () => void;
    onClosed: () => void;
    config: { saveConfig: MutationKeyConfig; invalidateRoute?: InvalidateRoute };
}

export const UploadPlanDialog = ({
    data,
    planData,
    mapPlanData,
    yupSchema,
    onSavedPlan,
    onClosed,
    config: { saveConfig, invalidateRoute },
}: UploadPlanDialog) => {

    const [value, setTabValue] = useState('create');

    const handleTabsChange = (event: any, value: any) => {
        setTabValue(value);
    };

    const [planArgs, setPlanArgs] = useState<any>({
        customerID: Number(data?.customerID) ?? '',
        officeID: Number(data?.officeID) ?? '',
        projectID: Number(data?.projectID) ?? '',
        unitID: Number(data?.unitID) ?? ''
    });

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'lg'}
        //  onClose={onClosed}
        >
            <DialogTitle id="form-dialog-title" sx={{ p: 0, m: 0 }}>
                <Tabs value={value} onChange={handleTabsChange}>
                    <Tab value="create" label={<div style={styling.tabHeading}>{data?.planID ? 'UPDATE PLAN' : 'ADD NEW PLAN'}</div>} />
                    <Tab value="mapped" label={<div style={styling.tabHeading}>ADD EXISTING PLAN</div>} hidden={data?.planID} />
                </Tabs>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 15,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers className="popupDilog">
                <TabPanel selectedValue={value} value="create">
                    <CreatePlanComponent
                        config={{
                            saveConfig: saveConfig,
                            invalidateRoute: invalidateRoute
                        }}
                        data={data}
                        planListData={planData}
                        yupSchema={yupSchema}
                        planRequestArgs={planArgs}
                        onSavedPlan={onSavedPlan}
                        onClosed={onClosed}
                    />
                </TabPanel>
                <TabPanel selectedValue={value} value="mapped">
                    <PlanMappedComponent
                        config={{
                            saveConfig: planApiKeyStore.mapPlans(),
                            invalidateRoute: invalidateRoute
                        }}
                        planData={mapPlanData}
                        planListData={planData}
                        planRequestArgs={planArgs}
                        onSavedPlan={onSavedPlan}
                        onClosed={onClosed} />
                </TabPanel>
            </DialogContent>
        </Dialog>
    );
}